export type MasterResumeNavigate = (options: {
  to: "/builder/$resumeId";
  params: { resumeId: string };
}) => Promise<unknown>;

export function getMasterResumeBuilderPath(masterResumeId: string) {
  return `/builder/${encodeURIComponent(masterResumeId)}`;
}

export async function navigateToMasterResumeBuilder(input: {
  masterResumeId: string;
  navigate: MasterResumeNavigate;
  recover: (path: string) => void;
}) {
  try {
    await input.navigate({
      to: "/builder/$resumeId",
      params: { resumeId: input.masterResumeId },
    });
    return "client" as const;
  } catch {
    try {
      input.recover(getMasterResumeBuilderPath(input.masterResumeId));
    } catch {
      // The server mutation is already committed; a failed recovery mechanism
      // must not turn the durable success into a second apply attempt or an
      // unrelated apply-error toast.
    }
    return "recovered" as const;
  }
}
